import styled from 'styled-components';
import { spacing, body2 } from 'ui/theme';
import { InputSearch } from 'ui/inputs';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  margin-top: ${spacing.base};
`;

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  vertical-align: middle;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
`;

export const BodyCheckboxCell = styled(Cell)`
  padding: 0 ${spacing.base} 0 ${spacing.plusQuarter};
`;

export const TableHeaderContainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
`;

export const StyledInputSearch = styled(InputSearch)`
  &&&&&& {
    padding-top: 0;
    padding-bottom: 0;
    border: none;
  }
`;
